import { currentSearch, getHostname, getSiteBrand } from "@/lib/siteHosts";

/** Company / legal identity for Terms, Privacy Policy, and DPA. Values follow the host brand. */

/** Empty / unset / whitespace-only env → ""; otherwise trimmed value. */
export function optionalEnv(value) {
  if (typeof value !== "string") {
    return "";
  }
  return value.trim();
}

/** Parenthetical ACN/ABN clause for inline legal copy, or "" when both are empty. */
export function formatCompanyRegistrationClause(company) {
  const parts = [];
  if (company?.acn) {
    parts.push(`ACN: ${company.acn}`);
  }
  if (company?.abn) {
    parts.push(`ABN: ${company.abn}`);
  }
  return parts.length ? ` (${parts.join("; ")})` : "";
}

export function getLegalCompany(hostname = getHostname(), search = currentSearch()) {
  const brand = getSiteBrand(hostname, search);
  if (!brand) return null;
  return {
    legalName: brand.legalName,
    brandName: brand.name,
    acn: brand.acn,
    abn: brand.abn,
    address: brand.address,
    supportEmail: brand.supportEmail,
    governingLaw: brand.governingLaw,
  };
}

export function formatAddressPhrase(address) {
  const value = typeof address === "string" ? address.trim() : "";
  return value ? `, of ${value}` : "";
}

export function hasCompanyText(value) {
  return typeof value === "string" && value.trim() !== "";
}

function liveCompanyField(key) {
  return {
    enumerable: true,
    get() {
      const company = getLegalCompany();
      if (!company) return "";
      return company[key];
    },
  };
}

/** Live view of getLegalCompany() so existing pages read the host brand at render time. */
export const LEGAL_COMPANY = Object.defineProperties(
  {},
  {
    legalName: liveCompanyField("legalName"),
    brandName: liveCompanyField("brandName"),
    acn: liveCompanyField("acn"),
    abn: liveCompanyField("abn"),
    address: liveCompanyField("address"),
    supportEmail: liveCompanyField("supportEmail"),
    governingLaw: liveCompanyField("governingLaw"),
  }
);
